// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"0acbf878","515":"76098988","591":"beead389","981":"337e6e56"}[chunkId] + ".chunk.css";
};